var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_2107)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.60052,
    cy: 6.91412,
    r: 2.20648,
    stroke: "#222627",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32604 9.27281L12.1259 6.04572C13.3041 5.39017 13.7116 3.89324 13.0283 2.73092V2.73092C12.3883 1.64221 11.0143 1.2354 9.88475 1.80018L4.72681 4.37916",
    stroke: "#222627",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35007 13.9929L14.1831 10.7474C15.368 10.0881 15.7778 8.58257 15.0907 7.4136V7.4136C14.447 6.31868 13.0651 5.90954 11.9291 6.47755L6.7417 9.07127",
    stroke: "#222627",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.80707,
    cy: 11.3271,
    r: 2.20648,
    stroke: "#222627",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.39398,
    cy: 11.3271,
    r: 2.20648,
    stroke: "#222627",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_2107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.c1fad248825fc4f47e21533806cd9080.svg";
export { ForwardRef as ReactComponent };